import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

export const previousConversationsModalStyles = StyleSheet.create({
	panel: {
		maxWidth: 940,
		width: '92vw',
		maxHeight: '82vh',
		padding: 0,
		overflow: 'hidden',
	},
	header: {
		padding: `${THEME.spacing.md}px ${THEME.spacing.xl}px ${THEME.spacing.md}px ${THEME.spacing.lg}px`,
		marginBottom: 0,
		borderBottom: `1px solid ${THEME.colors.border.light}`,
	},
	title: {
		...THEME.common.truncate,
		margin: 0,
		fontSize: THEME.typography.fontSizes.md,
		fontWeight: THEME.typography.fontWeights.bold,
		lineHeight: 1.4,
		color: THEME.colors.text.main,
	},
	body: {
		overflowY: 'auto',
		padding: `0 ${THEME.spacing.lg}px`,
	},
	table: {
		tableLayout: 'fixed',
	},
	// Content-box widths: the DataGrid header cell adds 20px of horizontal padding on top of these.
	// Keeping the metadata columns tight leaves the subject column roughly half the table.
	colMessages: {
		width: 84,
	},
	colAssignee: {
		width: 130,
	},
	colNumber: {
		width: 64,
	},
	colLastUpdate: {
		width: 100,
	},
	row: {
		cursor: 'pointer',
		':hover': { backgroundColor: THEME.colors.background.main },
	},
	subject: {
		...THEME.common.truncate,
		display: 'block',
		fontSize: 13,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
	},
	previewText: {
		...THEME.common.truncate,
		display: 'block',
		marginTop: 2,
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
	},
	messageCount: {
		display: 'inline-block',
		minWidth: 26,
		padding: `1px ${THEME.spacing.xs + 2}px`,
		border: `1px solid ${THEME.colors.border.main}`,
		borderRadius: 6,
		fontSize: THEME.typography.fontSizes.xxs,
		color: THEME.colors.text.light,
		textAlign: 'center',
	},
	cellMuted: {
		...THEME.common.truncate,
		fontSize: 13,
		color: THEME.colors.text.light,
	},
	footer: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.md,
		padding: `${THEME.spacing.sm}px ${THEME.spacing.lg}px`,
		borderTop: `1px solid ${THEME.colors.border.light}`,
	},
	// DialogFooter right-aligns its children from a media query, so push the count over with margin.
	footerCount: {
		marginRight: 'auto',
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
	},
	footerPagination: {
		padding: 0,
		borderTop: 'none',
		backgroundColor: 'transparent',
	},
});
